import { css } from '@emotion/css';

export const DayTradingInfoItem = css`
  display: flex;
  align-items: center;
  gap: 4px;
`;
